import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { mobileShopApi } from '../api/mobileShopApi';

export const store = configureStore({
  reducer: {
    [mobileShopApi.reducerPath]: mobileShopApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(mobileShopApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
